import { BRAND, isBrandOV } from '../../../constants/main';
import { getAssetUrl } from '@utils/assetUrl.utils';
import ReactImageFallback from 'react-image-fallback';
import React from 'react';

export interface ICarOptionDetail {
    category: string;
    title: string;
    image: string;
    description: string;
    className: string;
}

const ModalCarOptionDetailTemplate = ({ category, title, image, description, className }: ICarOptionDetail) => {
    return (
        <div className={className}>
            {category && <p className="option-detail__category">{category}</p>}
            <p className="option-detail__title">{title}</p>
            <ReactImageFallback
                className="option-detail__image"
                src={image}
                fallbackImage={!isBrandOV ? getAssetUrl(`/images/optionFallback.${BRAND}.png`) : ''}
            />
            <p className="option-detail__description">
                <ul>{description}</ul>
            </p>
        </div>
    );
};

export default ModalCarOptionDetailTemplate;
